import React from 'react';

import styles from './PopupForm.module.scss';

interface Props {
  children?: any;
}

const PopupFormHeader = ({ children }: Props) => (
  <h3 className={styles.popup_form__header}>{children}</h3>
);

PopupFormHeader.defaultProps = {
  children: [],
};

export default PopupFormHeader;
